import clsx from "clsx";
import { ToggleFontSize } from "./ToggleFontSize";
import { ToggleLang } from "./ToggleLang";
import { UserMenu } from "./UserMenu";

export const Header = () => {
  return (
    <div className="bg-[var(--sky-primary)]" style={{ height: "40px" }}>
      <div
        className={clsx(
          "flex items-center justify-between m-auto px-4",
          "ckan-md:w-[750px] ckan-lg:w-[970px] ckan-xl:w-[1180px] "
        )}
      >
        <div className="h-full flex items-center">
          <ToggleFontSize />

          <ToggleLang />
        </div>

        {/* Reflects the portal's login state via /api/pdp/whoami: anonymous ->
            Log in / Register; logged in -> the CKAN account bar. */}
        <UserMenu />
      </div>
    </div>
  );
};
